const translation = {
  Today: "Aujourd'hui",
  Yesterday: 'Hier',
  'Last 7 days': '7 derniers jours',
  'Last Week': ' La semaine dernière',
  'Last 30 days': '30 derniers jours',
  'Last Month': 'Mois dernier',

  Uptime: 'Durée de la baisse',
  Maintanance: 'Entretien',
  'Unplanned Outages': ' Pannes imprévues',
  'Operational Hours': "Heures d'ouverture",

  'Prevented Down Time': 'Temps de disponibilité',
  'Preventive Action Taken': 'Mesures préventives prises',

  'Total Repair Time': 'Durée totale de réparation',
  'Number of Incidence': "Nombre d'incidences",

  Cases: 'Cases',
  Open: 'Ouvrir',
  Ongoing: 'En cours',
  Closed: 'Fermée',
  Incidents: 'Incites',
  Requests: 'Demandes',

  'Average Throughput': 'Débit moyen',

  'Network Map': 'Carte du réseau',
  'Total Sites': 'Total des sites',
  'Online Sites': 'Sites en ligne',
  'Degraded Sites': 'Sites dégradés',

  Events: 'Événements',
}

export default translation
